import { format, formatDistanceToNow, parseISO } from 'date-fns';
import { IST } from './constants.js';

/**
 * Format a UTC ISO string as IST date+time for display.
 */
export function formatIST(dateStr, fmt = 'dd MMM yyyy, hh:mm a') {
  if (!dateStr) return '—';
  try {
    const d = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr;
    // Offset UTC to IST (+5:30)
    const ist = new Date(d.getTime() + 5.5 * 60 * 60 * 1000);
    return format(ist, fmt);
  } catch {
    return '—';
  }
}

export function formatDate(dateStr) {
  return formatIST(dateStr, 'dd MMM yyyy');
}

export function timeAgo(dateStr) {
  if (!dateStr) return '—';
  try {
    return formatDistanceToNow(parseISO(dateStr), { addSuffix: true });
  } catch {
    return '—';
  }
}

export function formatBytes(bytes) {
  if (!bytes) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${units[i]}`;
}

/**
 * Returns the Indian financial year label for a given date.
 * e.g. "FY 2025-26"
 */
export function getFinYearLabel(date = new Date()) {
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const start = month >= 4 ? year : year - 1;
  return `FY ${start}-${String(start + 1).slice(-2)}`;
}
